/*----- Core -----*/
import ImageProcessor	from './Processor'

/*----- Components -----*/
import Notification from "../commons/Notification"

/*----- Export -----*/
export default async function imageReader(images,setImagesIsLoading) {
	let readyImages = []
	setImagesIsLoading(true)
	try {
		for (let i = 0; i < images.length; ++i) {
			if ( !images[i].type.match('image/jpeg') ) {
				Notification('Solo estan permitidas imagenes jpg', 'error')
				break
			} else if (images.length > 3) {
				Notification('Solo puedes cargar hasta 3 imágenes', 'Error')
				break
			}
			const file = await ImageProcessor(images[i])
			readyImages.push(file)	
		}
	} catch (error) {
		Notification(error.message, 'error')
		console.log(error.message)
	}
	return readyImages.length < 1? null : readyImages
}